import axios from '@axios'
import { get } from '@vueuse/core'

const route = 'register/product'

export default {
  namespaced: true,
  state: {
    raw_materials: [],
  },
  getters: {
    getRawMaterials: (state) => state.raw_materials,
  },
  mutations: {
    setRawMaterials(state, raw_materials) {
      state.raw_materials = raw_materials
    }
  },
  actions: {
    getAll(context, {
      itemsPerPage, page, search, filters, sortBy,
    }) {
      const pagination = `?page=${page}&items_per_page=${itemsPerPage}&sort_by=${sortBy}&search=${search}`

      return axios.post(route + pagination, filters)
    },



    store(context, data) {
      const formData = new FormData()
      formData.append('product', JSON.stringify(data.product))
      formData.append('img', data.img)
      formData.append('raw_materials', JSON.stringify(data.raw_materials))
      return axios.post(`${route}/store`, formData)
    },

    update(context, data) {
      const formData = new FormData()
      formData.append('_method', 'PUT')
      formData.append('product', JSON.stringify(data.product))
      formData.append('img', data.img)
      formData.append('raw_materials', JSON.stringify(data.raw_materials))

      return axios.post(`${route}/update/${data.product.id}`, formData)
    },

    destroy(context, product) {
      return axios.delete(`${route}/destroy/${product.id}`)
    },

    getCategoryProduct(context) {
      return axios.get(`${route}/get_category_product`)
    },

    // brand
    storeBrand(context, brand) {
      return axios.post('register/brand', brand)
    },

    // category product
    storeCategory(context, category) {
      return axios.post('register/category_product', category)
    },

    //
    // uploadPhoto(context,data){
    //   const formData = new FormData()
    //   formData.append('img',data.img)
    //   return axios.post(route + "/photo/" + data.product_id, formData)
    // },
    // load photo
    getPhotos(context, product_id) {
      return axios.get(`${route}/photo/${product_id}`)
    },

    // delete photo
    deletePhoto(context, data) {
      return axios.delete(`${route}/remove_photo/${data.product_id}`)
    },

    // carregas as vendas de um produto
    getSales(context, product_id) {
      return axios.get(`${route}/sales/${product_id}`)
    },

    // donwload excel
    exportExcel(context, params) {
      return axios.post(`${route}/export_excel`, params, { responseType: 'blob' })
    },

    /**
     * carrega  os pedidos de compra do produto
     */
    loadPurchaseOrderPerProduct(context, product_id) {
      return axios.get(`${route}/purchase_order/${product_id}`)
    },

    /**
     * carrega  as vendas do produto
     */
    loadSalePerProduct(context, product_id) {
      return axios.get(`${route}/sales/${product_id}`)
    },

    /**
     *  carrega  o historico de movimentacoes no estoque
     */
    loadStockPerProduct(context, product_id) {
      return axios.get(`${route}/stock/${product_id}`)
    },

    /**
     * carrega  os produtos para adicionar na materia prima
     */
    loadProducts(context,search) {
      return axios.post(`${route}/get_search_products_raw_materials`, { search })
    },

    loadRawMaterials(context, product_id) {
      return axios.get(`${route}/raw_materials/${product_id}`)
    }
    

    // /**
    //  * addicionar materia prima
    //  */
    // addItemRawMaterial(context, data) {
    //   return axios.post(`${route}/add_item_raw_material`, data)
    // }

  },
}
